import React from "react";
import { Outlet } from "react-router-dom";

const Layouts = (props) => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Layouts